import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] grid place-items-center px-6" data-testid="admin-login-page">
      <Seo title="Admin Sign In" noIndex path="/admin/login" />
      <div className="w-full max-w-md glass rounded-3xl p-8">
        <div className="h-12 w-12 grid place-items-center rounded-2xl bg-primary text-primary-foreground"><Lock className="w-5 h-5" /></div>
        <h1 className="text-2xl font-heading mt-5">Admin sign in</h1>
        <p className="text-sm text-muted-foreground mt-1">Manage your portfolio content.</p>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-sm text-muted-foreground">Email</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" className="mt-1.5 w-full rounded-xl bg-background/60 border border-border px-4 py-3 outline-none focus:ring-2 focus:ring-ring" placeholder="admin@portfolio.dev" />
          </div>
          <div>
            <label className="text-sm text-muted-foreground">Password</label>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" className="mt-1.5 w-full rounded-xl bg-background/60 border border-border px-4 py-3 outline-none focus:ring-2 focus:ring-ring" placeholder="••••••••" />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
          <button disabled={loading} data-testid="login-submit-button" className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground px-6 py-3 font-medium hover:opacity-90 transition-opacity disabled:opacity-60">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
